"use strict";

define('rs/modals/table.finder/table.finder.view',['require','exports','module','rs/modals/finder/finder.view'],function (require, exports, module) {
  var FinderView = require('rs/modals/finder/finder.view');
  var TableFinderView = FinderView.extend({
    modalClassName: 'table-finder modal-lg',
    events: {},
    finderMsgs: {
      "default": 'Use the search box above to find records.',
      loading: 'Searching for your results...',
      none: 'No records found.'
    },
    getRowContainer: function getRowContainer() {
      return this.getItemsContainer().find('.e3-table-row-container');
    },
    handleFinderFilterAction: function handleFinderFilterAction() {
      var delegate = this.getDelegate();
      this.disableFilter();
      this.showFinderMsg(this.finderMsgs.loading);
      delegate.refresh().bind(this).then(this.enableFilter);
    },
    showFinderMsg: function showFinderMsg(msg) {
      var rowContainer = this.getRowContainer(),
        msgElement = this.getFinderMsg();
      rowContainer.hide();
      msgElement.text(msg || this.finderMsgs["default"]);
      msgElement.parent().show();
    },
    showTableContents: function showTableContents(results) {
      if (!results.length) {
        this.showFinderMsg(this.finderMsgs.none);
        return;
      }
      this.getFinderMsg().parent().hide();
      this.getRowContainer().show();
    }
  });
  module.exports = TableFinderView;
});

